import type { CylinderGeometry, Object3D, PlaneGeometry } from "three"
import { HALF_PI } from "../../core/util/math/Math"

/**
 * Rotates a plane to lay flat on the ground.
 * 
 * @param object that is probably a plane
 */
export default function rotatePlaneToLayFlat(
  object: Object3D | CylinderGeometry | PlaneGeometry
): void {
  object.rotateX(-HALF_PI)
}